import genericRepositoryService from "../../../services/genericRepositoryService";
import { ISearchLessonRequest } from "../../../models/ISearchLessonRequest";
import { MicroLessonFilter } from "./types";
import { PAGE_SIZE } from "./constants";
import { ISearchLessonResponse } from "../../../models/ISearchLessonResponse";

export const fetchMicroLessons = async (filters: MicroLessonFilter[], pageNumber = 1, pageSize = PAGE_SIZE) => {
  const filter: ISearchLessonRequest["filter"] = {};

  filters.forEach((item) => {
    const value = item.value.trim();

    if (item.type === "name") {
      filter.title = value;
      return;
    }

    if (item.type === "tags") {
      filter.tags = filter.tags ? `${filter.tags},${value}` : value;
      return;
    }

    if (item.type === "lessonId") {
      filter.lessonId = value;
      return;
    }

    if (item.type === "objectives") {
      filter.objectives = filter.objectives ? `${filter.objectives},${value}` : value;
      return;
    }

    if (item.type === "from") {
      filter.startDate = value.split(":")[1].trim();
      return;
    }

    if (item.type === "to") {
      filter.endDate = value.split(":")[1].trim();
    }
  });

  const queryParams = new URLSearchParams();
  queryParams.set("pageNumber", pageNumber.toString());
  queryParams.set("pageSize", pageSize.toString());

  if (filter.title) {
    queryParams.set("name", filter.title);
  }

  if (filter.lessonId) {
    queryParams.set("lessonId", filter.lessonId);
  }

  if (filter.objectives) {
    const objectivesArray = filter.objectives.split(",");
    objectivesArray.forEach((objective) => {
      queryParams.append("objectives", objective);
    });
  }

  if (filter.tags) {
    const tagsArray = filter.tags.split(",");
    tagsArray.forEach((tag) => {
      queryParams.append("tagKeys", tag);
    });
  }

  if (filter.startDate) {
    queryParams.set("startDate", filter.startDate);
  }

  if (filter.endDate) {
    queryParams.set("endDate", filter.endDate);
  }

  const queryString = queryParams.toString();
  const response = await genericRepositoryService.searchLesson(queryString);
  return response;
};

export const addMicroLesson = async (microlessonIds: number[]) => {
  const response = await genericRepositoryService.cloneMicroLesson({ microlessonIds });
  return response;
};

export const normalizeSearchResponse = (data: ISearchLessonResponse["data"], context: { lessonId: number | null }) => {
  return data.map((item) => ({
    ...item,
    disabled: context.lessonId?.toString() === item.lessonId.toString(),
  }));
};

/**
 * Checks if any micro lesson page has secondary/alternative audio
 * Works for both add micro lesson response (array of items with pageManifest.Pages)
 * and update micro lesson response (single item with pageManifest.Pages)
 */
export const hasMicroLessonSecondaryAudio = (pages: any[]): boolean => {
  for (const page of pages) {
    const narrationAudios = page?.PageManifest?.narrationAudios || page?.pageManifest?.narrationAudios || [];
    for (const audio of narrationAudios) {
      if (audio?.language === "secondary") {
        return true;
      }
    }
  }
  return false;
};
